module.exports = __webpack_public_path__ + "static/img/main.b66458c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/KerbalSpaceProgram/intro/main.jpg
// module id = Q75k
// module chunks = 0